import actions from '../actions';

const initialState = {
  value: null,
};

const hoverSourceReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.HOVER_SOURCE_METRIC_RELATION:
      return {
        ...state,
        value: action.payload,
      };
    default:
      return state;
  }
};

export default hoverSourceReducer;
